import { $api } from "@/services/api";
import store from "@/store";

const state = {
  nonCatalogItems: [],
  nonCart: [],
  nonCartTotal: [],
  nonCartDraftCounter: 0,
  nonCartInProcessCounter: 0,
  nonCartRequesterCounters: {
    draft: 0,
    inProcess: 0,
  },
  totalNonCartApproval: {
    all: 0,
    inProcess: 0,
    history: 0,
  },
  totalProcurementSourcingApproval: {
    all: 0,
    inProcess: 0,
    history: 0
  },
  procurementSourcingCounter: {
    all: 0,
    inProcess: 0,
    waitingForApproval: 0,
    history: 0,
  },
  nonCartStatus: "",
  nonCartPRNumber: "",
  nonCartRequestId: "",
};
const getters = {
  nonCatalogItems: (state) => state.nonCatalogItems,
  nonCart: (state) => state.nonCart,
  nonCartTotal: (state) => state.nonCartTotal,
  nonCartDraftCounter: (state) => state.nonCartDraftCounter,
  nonCartInProcessCounter: (state) => state.nonCartInProcessCounter,
  totalNonCartApproval: (state) => state.totalNonCartApproval,
  totalProcurementSourcingApproval: (state) => state.totalProcurementSourcingApproval,
  procurementSourcingCounter: (state) => state.procurementSourcingCounter,
  nonCartStatus: (state) => state.nonCartStatus,
  nonCartRequestId: (state) => state.nonCartRequestId,
  nonCartRequesterCounters: (state) => state.nonCartRequesterCounters,
  nonCartPRNumber: (state) => state.nonCartPRNumber
};
const mutations = {
  async setInProcessNonCartApproval(state, total) {
    state.totalNonCartApproval.inProcess = total;
  },
  async setInProcessProcurementSourcingApproval(state, total) {
    state.totalProcurementSourcingApproval.inProcess = total;
  },
  setNonCatalogItems(state, items) {
    state.nonCatalogItems = items;
  },
  updateNonCatalogItem(state, item) {
    const found = state.nonCatalogItems.find(
      (i) => i.item_number === item.item_number
    );

    if (found) {
      state.nonCatalogItems = state.nonCatalogItems.map((i) => {
        if (i.item_number === item.item_number) {
          return {
            ...item,
          };
        } else {
          return i;
        }
      });
    } else {
      state.nonCatalogItems.push(item);
    }

    // console.log(state.nonCatalogItems);
  },
  removeNonCatalogItem(state, itemNumber) {
    state.nonCatalogItems = state.nonCatalogItems.filter(
      (item) => item.item_number !== itemNumber
    );
  },
  clearNonCatalogItems(state) {
    state.nonCatalogItems = [];
  },
  setNonCart(state, nonCartsList) {
    state.nonCart = nonCartsList;
  },
  setNonCartTotal(state, total) {
    state.nonCartTotal = total;
  },
  clearNonCart(state) {
    state.nonCart = [];
  },
  updateDraftCounter(state, counter) {
    state.nonCartDraftCounter = counter;
  },
  updateInProcessCounter(state, counter) {
    state.nonCartInProcessCounter = counter;
  },
  updateProcurementSourcingCounters(state, counters) {
    state.procurementSourcingCounter.inProcess = counters.inProcess;
    state.procurementSourcingCounter.waitingForApproval = counters.waitingForApproval;
    state.procurementSourcingCounter.history = counters.history;
    state.procurementSourcingCounter.all = process.env?.VUE_APP_ENABLE_SOURCING_APPROVAL_FLOW === "yes" ? counters.inProcess + counters.waitingForApproval : counters.inProcess
  },
  updateNonCartStatus(state, status) {
    state.nonCartStatus = status;
  },
  updateNonCartRequestId(state, id) {
    state.nonCartRequestId = id;
  },
  updateNonCartPRNumber(state, prNumber) {
    state.nonCartPRNumber = prNumber;
  },
  updateNonCartRequesterCounters(state, counters) {
    state.nonCartRequesterCounters.draft = counters.draft;
    state.nonCartRequesterCounters.inProcess = counters.inProcess;
  },
};
const actions = {
  updateNonCatalogItem({ commit }, payload) {
    commit("updateNonCatalogItem", payload);
  },
  removeNonCatalogItem({ commit }, itemNumber) {
    commit("removeNonCatalogItem", itemNumber);
  },
  clearNonCatalogItems({ commit }) {
    commit("clearNonCatalogItems");
  },
  setNonCatalogItems({ commit }, items) {
    commit("setNonCatalogItems", items);
  },
  async reCalculateGLAccount({ state, commit }, costCenterCode) {
    if (state.nonCatalogItems.length) {
      const reCalculatePromises = state.nonCatalogItems.map(async (item) => {
        let productGLAccount = null;

        if (
          costCenterCode.slice(
            costCenterCode.length - 4,
            costCenterCode.length - 3
          ) === "0" ||
          costCenterCode.slice(
            costCenterCode.length - 4,
            costCenterCode.length - 3
          ) === "Z"
        ) {
          // Case: Head Office (HO)
          const getProductGLAccountResponse =
            await $api.m_product_gl_accounts.getProductGLAccounts({
              department_type: "Expense",
              is_cogs: 0,
              material_group_code: item.material_group_code,
            });

          if (
            getProductGLAccountResponse &&
            getProductGLAccountResponse.length
          ) {
            productGLAccount = getProductGLAccountResponse[0];
          }
        } else {
          // Case: Other..
          let department = null;

          const getDepartmentResponse = await $api.m_departments.getDepartments(
            {
              code: costCenterCode.slice(-3),
            }
          );

          if (getDepartmentResponse && getDepartmentResponse.length) {
            department = getDepartmentResponse[0];

            const getProductGLAccountResponse =
              await $api.m_product_gl_accounts.getProductGLAccounts({
                department_type: department.department_type,
                is_cogs: department.is_cogs,
                material_group_code: item.material_group_code,
              });

            if (
              getProductGLAccountResponse &&
              getProductGLAccountResponse.length
            ) {
              productGLAccount = getProductGLAccountResponse[0];
            }
          }
        }

        return {
          ...item,
          account_group: productGLAccount?.gl_account_group,
          gl_account_code: productGLAccount?.gl_account_code,
          gl_account_description: productGLAccount?.gl_account_description_th,
        }
      })

      const reCalculateData = await Promise.all(reCalculatePromises);
      commit("setNonCatalogItems", reCalculateData);
    }
  },
  updateDraftCounter({ commit }, counter) {
    commit("updateDraftCounter", counter);
  },
  updateInProcessCounter({ commit }, counter) {
    commit("updateInProcessCounter", counter);
  },
  clearNonCart({ commit }) {
    commit("clearNonCart");
  },
  async getTotalNonCartApproval({ commit }) {
    const nonCartApprovalItemRes = await $api.v_non_cart_approval_items.get({
      aduser: store.getters.user.userName,
      status: "Waiting",
      is_active: true,
    });

    if (nonCartApprovalItemRes) {
      commit("setInProcessNonCartApproval", nonCartApprovalItemRes.total);
    } else {
      commit("setInProcessNonCartApproval", 0);
    }
  },
  async getTotalProcurementSourcingApproval({ commit }) {
    const approvalItemsRes = await $api.v_sourcing_approval_items.get({
      aduser: store.getters.user.userName,
      status: "Waiting",
      is_active: true,
    });

    if (approvalItemsRes) {
      commit("setInProcessProcurementSourcingApproval", approvalItemsRes.total);
    } else {
      commit("setInProcessProcurementSourcingApproval", 0);
    }
  },
  async getProcurementSourcingCounter({ commit }) {
    const inProcessParams = store.getters.isSpecialUser
      ? {
        "status[$in][0]": "Approved",
        "status[$in][1]": "Edit Error",
        "status[$in][2]": "Error",
        "status[$in][3]": "Reworked",
        "pr_number[$gt]": 0,
        is_sourcing: true,
        is_active: true,
      }
      : {
        "status[$in][0]": "Approved",
        "status[$in][1]": "Edit Error",
        "status[$in][2]": "Error",
        "status[$in][3]": "Reworked",
        "pr_number[$gt]": 0,
        is_sourcing: true,
        is_active: true,
        buyer_employee_code: store.getters.user.empCodeHC,
      }

    const waitingForApprovalParams = store.getters.isSpecialUser
      ? {
        status: "Waiting for Approval",
        is_active: true,
        is_sourcing: true
      }
      : {
        status: "Waiting for Approval",
        is_active: true,
        buyer_employee_code: store.getters.user.empCodeHC,
        is_sourcing: true
      }

    const historyParams = store.getters.isSpecialUser
      ? {
        "status[$in][0]": "Sourcing Approved",
        "status[$in][1]": "Reworked",
        is_active: true,
      }
      : {
        "status[$in][0]": "Sourcing Approved",
        "status[$in][1]": "Reworked",
        is_active: true,
        buyer_employee_code: store.getters.user.empCodeHC,
      }

    // if (process.env.VUE_APP_ENABLE_SOURCING_APPROVAL_FLOW === "yes") {
    //   inProcessParams["is_sourcing"] = true;
    //   inProcessParams["status[$in][3]"] = "Reworked"
    //   historyParams["status[$in][1]"] = "Reworked"
    // } else {
    //   historyParams["status[$in][1]"] = "Reworked"
    // }

    const inProcess = await $api.v_non_carts.get(inProcessParams);
    const waitingForApproval = await $api.v_non_carts.get(waitingForApprovalParams);
    const history = await $api.v_non_carts.get(historyParams);

    commit("updateProcurementSourcingCounters", {
      inProcess: inProcess.total ? inProcess.total : 0,
      waitingForApproval: waitingForApproval.total ? waitingForApproval.total : 0,
      history: history.total ? history.total : 0,
    });
  },
  updateNonCartStatus({ commit }, status) {
    commit("updateNonCartStatus", status);
  },
  clearNonCartStatus({ commit }) {
    commit("updateNonCartStatus", "");
  },
  updateNonCartRequestId({ commit }, id) {
    commit("updateNonCartRequestId", id);
  },
  clearNonCartRequestId({ commit }) {
    commit("updateNonCartRequestId", "");
  },
  updateNonCartPRNumber({ commit }, prNumber) {
    commit("updateNonCartPRNumber", prNumber)
  },
  clearNonCartPRNumber({ commit }) {
    commit("updateNonCartPRNumber", "")
  },
  async getNonCartRequesterCounters({ commit }) {
    const draftResponse = await $api.v_non_carts.getByQueryString(
      store.getters.isSpecialUser
        ? `?status[$in][0]=Draft&status[$in][1]=Reworked&status[$in][2]=Error&is_active=true${process.env.VUE_APP_ENABLE_SOURCING_APPROVAL_FLOW === "yes" ? "&is_sourcing=false" : ""}`
        : `?status[$in][0]=Draft&status[$in][1]=Reworked&status[$in][2]=Error&requested_by_user=${store.getters.user.userName}&is_active=true${process.env.VUE_APP_ENABLE_SOURCING_APPROVAL_FLOW === "yes" ? "&is_sourcing=false" : ""}`
    );
    const inProcessResponse = await $api.v_non_carts.getByQueryString(
      store.getters.isSpecialUser
        ? `?status[$in][0]=Waiting for Approval&status[$in][1]=Pending&is_active=true&is_sourcing=false`
        : `?status[$in][0]=Waiting for Approval&status[$in][1]=Pending&requested_by_user=${store.getters.user.userName}&is_active=true&is_sourcing=false`
    );
    commit("updateNonCartRequesterCounters", {
      draft: draftResponse && draftResponse.total ? draftResponse.total : 0,
      inProcess:
        inProcessResponse && inProcessResponse.total
          ? inProcessResponse.total
          : 0,
    });
  },
};

export default { state, getters, mutations, actions };
